<script>
import Drawer from "@/components/drawer";
import { required } from "vuelidate/lib/validators";
import MultiSelect from "vue-multiselect";
import VueDropify from "vue-dropify";

// Custom Components
import PageHeader from "@/components/page-header";
import BookingDetails from "@/components/booking-details.vue";
import { authComputed } from "@/helpers/helpers";
import { otherOptions, priorityOpt } from "@/helpers/global.variable.js";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import appConfig from "@/app.config";
import Middleware from "@/helpers/middlewares";

export default {
  page: {
    title: "brand list",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  computed: {
    ...authComputed,
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
  },
  components: {
    PageHeader,
    BookingDetails,
    Drawer,
    MultiSelect,
    VueDropify,
  },
  data() {
    return {
      title: "Maintenance Requests",
      reqData: [],
      isStillLoading: false,
      drawerOpener: false,
      otherOptions: otherOptions,
      priorityOpt: priorityOpt,
      assignToOptions: [{ value: "auto_assign", text: "Auto Assign" }],
      roomOptions: [],
      issueList: [],
      isLoading: false,
      submitted: false,
      issueHash: null,
      newTitle: null,
      description: null,
      assigned_by: { value: "auto_assign", text: "Auto Assign" },
      roomNumber: null,
      attachment: null,
      prior: "normal",
      stat: "pending",
      issue: null,
      viewBookingDetails: false,
      selectedBooking: null,
      imgURL: null,
    };
  },
  validations: {
    newTitle: { required },
    prior: { required },
    stat: { required },
    issueHash: { required },
    description: { required },
  },
  mounted() {
    this.requestList();
  },
  methods: {
    async getAllMRs() {
      this.is_data_loading = true;
      const query = "";
      await UserService.getAllMaintenceRequest(query).then((response) => {
        if (response) {
          response.map((item) => {
            this.issueList.push({
              text: item.name,
              value: item.id,
            });
          });
        }
        this.issueHash = response[0].id;
      });
    },
    async getStaffList() {
      try {
        const response = await UserService.getStaffList();
        response.map((item) => {
          this.assignToOptions.push({
            text: item.first_name + item.last_name,
            value: item.id,
          });
        });
      } catch (error) {
        errorHandler(error);
      }
    },
    async getRoomList() {
      try {
        const response = await UserService.getRoomList();
        response.map((item) => {
          this.roomOptions.push({
            text: item.room_number,
            value: item,
          });
        });
      } catch (error) {
        errorHandler(error);
      }
    },
    async requestList() {
      this.isStillLoading = true;
      const response = await UserService.getAllMaintenanceReq();
      if (response) {
        response.map((item) => {
          let guestName = null;
          if (item.guest !== null) {
            const firstName = item.guest.first_name
              ? item.guest.first_name
              : "-";
            const lastName = item.guest.last_name ? item.guest.last_name : "-";
            guestName = lastName + " " + firstName;
          } else {
            if (item.room !== null) {
              const firstName =
                item.room.booking && item.room.booking.first_name
                  ? item.room.booking.first_name
                  : "-";
              const lastName =
                item.room.booking && item.room.booking.last_name
                  ? item.room.booking.last_name
                  : "-";
              guestName = lastName + " " + firstName;
            }
          }
          item = {
            ...item,
            guestName,
          };
          this.reqData.push(item);
        });
        this.isStillLoading = false;
      }
    },
    async openers(data) {
      if (data) {
        localStorage.setItem("base_id", JSON.stringify(data.id));
      }
      this.$router.push("/main-req-logs");
    },
    newMaintenanceRequestForm() {
      this.drawerOpener = !this.drawerOpener;
      if (this.drawerOpener) {
        this.getAllMRs();
        this.getStaffList();
        this.getRoomList();
      }
    },
    async addNewReq() {
      this.submitted = true;
      this.$v.$touch();
      this.isLoading = true;
      if (this.$v.$invalid) {
        this.isLoading = false;
        return;
      } else {
        let appData = new FormData();
        appData.append("hotel", this.hotel.id);
        appData.append("maintenance_issue", this.issueHash);
        appData.append("title", this.newTitle);
        appData.append("priority", this.prior);
        appData.append("status", this.stat);
        appData.append("description", this.description);
        if (this.attachment !== null) {
          appData.append("attachment", this.attachment);
        }
        if (this.roomNumber == "auto_assign") {
          const randomRoom = Math.floor(
            Math.random() * this.roomOptions.length
          );
          const room = this.roomOptions[randomRoom].value;
          appData.append("room", room.id);
          if (room.booking) {
            appData.append("booking", room.booking.id);
          }
        } else {
          appData.append("room", this.roomNumber.value.id);
          if (this.roomNumber.value.booking) {
            appData.append("booking", this.roomNumber.value.booking.id);
          }
        }

        try {
          const response = await UserService.createNewMaintenanceReq(appData);
          if (response) {
            this.isLoading = false;
            Middleware.notification(
              "Details logged successfully !!",
              "success"
            );

            this.drawerOpener = !this.drawerOpener;
          } else {
            Middleware.notification("There has been some error !!", "danger");
          }
        } catch (error) {
          this.isLoading = false;
          errorHandler(error);
        }
      }
    },
    // Method is used to open booking details drawer
    openBookingDetails(data = null) {
      if (data.id != null) {
        this.selectedBooking = data;
        this.viewBookingDetails = true;
      } else {
        Middleware.notification("No bookings found !!", "info");
      }
    },
    // Method is used to handle change image
    changeImage(event) {
      this.attachment = event[0] == undefined ? null : event[0];
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="newMaintenanceRequestForm"
      text="Add Request"
      :isButton="true"
    />
    <b-card>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th class="text-left">Ticket #</th>
              <th class="text-left">Issue Title</th>
              <th class="text-left">Category</th>
              <th class="text-left">Room No.</th>
              <th class="text-left">Guest Name</th>
              <th class="text-center">Priority</th>
              <th class="text-center">Status</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody v-if="isStillLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 8" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody class="text-capitalize" v-else>
            <tr v-for="req in reqData" :key="req.id">
              <td class="text-left" @click="openers(req)">
                {{ req.ticket_number ? req.ticket_number : "-" }}
              </td>
              <td @click="openers(req)">
                {{ req.title ? req.title : "Not Available" }}
              </td>
              <td @click="openers(req)">
                {{
                  req.maintenance_issue.name
                    ? req.maintenance_issue.name
                    : "Not Available"
                }}
              </td>
              <td class="text-left">
                {{ req.room ? req.room.room_number : "-" }}
              </td>
              <td
                class="text-left"
                @click="openBookingDetails({ id: req.booking })"
              >
                {{ req.guestName !== null ? req.guestName : "- -" }}
              </td>
              <td class="text-center">
                <span
                  class="badge py-1 px-2 card-badge"
                  :class="[
                    req.priority == 'normal'
                      ? 'badge-soft-info'
                      : req.priority == 'urgent'
                      ? 'badge-soft-warning'
                      : 'badge-soft-danger',
                  ]"
                >
                  {{ req.priority ? req.priority : "Not Specified" }}</span
                >
              </td>
              <td class="text-center">
                <span
                  class="badge py-1 px-2 card-badge"
                  :class="[
                    req.status == 'pending'
                      ? 'badge-soft-danger'
                      : req.status == 'assigned'
                      ? 'badge-soft-info'
                      : req.status == 'in_progress'
                      ? 'badge-soft-warning'
                      : req.status == 'completed'
                      ? 'badge-soft-success'
                      : 'badge-soft-primary',
                  ]"
                >
                  {{ req.status ? req.status.replace("_", " ") : "-" }}
                </span>
              </td>
              <td class="text-center" @click="openers(req)">
                <i
                  class="fas fa-solid fa-eye mx-1"
                  v-b-popover.hover="'Watch logs OR Edit request!'"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <!-- Drawer For New Request -->
    <Drawer
      @close="newMaintenanceRequestForm()"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="drawerOpener">
        <div class="col-md-12">
          <div class="row">
            <h4>New Request</h4>
            <hr />
            <div class="col-md-4">
              <div class="mb-3">
                <label for=""
                  >issue title<span class="text-danger ms-1">*</span></label
                >
                <b-form-input
                  type="text"
                  v-model="newTitle"
                  autocomplete="off"
                  placeholder="Issue Title"
                  :class="{
                    'is-invalid': submitted && $v.newTitle.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.newTitle.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.newTitle.required"
                    >issue title is required.</span
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label for="category"
                  >Category<span class="text-danger ms-1">*</span></label
                >
                <b-form-group>
                  <b-form-select
                    class="form-select"
                    v-model="issueHash"
                    :options="issueList"
                    id=""
                    type="text"
                    :class="{
                      'is-invalid': submitted && $v.issueHash.$error,
                    }"
                  ></b-form-select>
                  <div
                    v-if="submitted && $v.issueHash.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.issueHash.required"
                      >issue type is required.</span
                    >
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label for=""
                  >priority<span class="text-danger ms-1">*</span></label
                >
                <b-form-group>
                  <b-form-select
                    class="form-select"
                    :options="priorityOpt"
                    v-model="prior"
                    type="text"
                    :class="{
                      'is-invalid': submitted && $v.prior.$error,
                    }"
                  ></b-form-select>
                  <div
                    v-if="submitted && $v.prior.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.prior.required"
                      >priority selection is required.</span
                    >
                  </div>
                </b-form-group>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="room_number">Room</label>
                <b-form-group>
                  <MultiSelect
                    v-model="roomNumber"
                    :options="roomOptions"
                    :show-labels="false"
                    track-by="value"
                    label="text"
                    id="room"
                  />
                </b-form-group>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label for="assign_to">Assign To</label>
                <b-form-group>
                  <MultiSelect
                    :options="assignToOptions"
                    v-model="assigned_by"
                    :show-labels="false"
                    track-by="value"
                    label="text"
                    id="room"
                  />
                </b-form-group>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-3">
                <label for="">status<span class="text-danger">*</span></label>
                <b-form-group>
                  <b-form-select
                    class="form-select"
                    :options="otherOptions"
                    v-model="stat"
                    type="text"
                    :class="{
                      'is-invalid': submitted && $v.stat.$error,
                    }"
                  ></b-form-select>
                  <div
                    v-if="submitted && $v.stat.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.stat.required"
                      >status selection is required.</span
                    >
                  </div>
                </b-form-group>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for=""
                  >Description <span class="text-danger">*</span></label
                >
                <b-form-textarea
                  type="text"
                  v-model="description"
                  autocomplete="off"
                  placeholder="Description"
                  rows="9"
                  :class="{
                    'is-invalid': submitted && $v.description.$error,
                  }"
                ></b-form-textarea>
                <div
                  v-if="submitted && $v.description.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.description.required"
                    >Description is required.</span
                  >
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="">Attachment </label>
                <VueDropify
                  @upload="changeImage($event)"
                  :src="imgURL"
                  message="Drop image here or click to select"
                />
              </div>
            </div>
            <hr />
            <div class="col-md-12">
              <b-button
                class="float-end ms-2"
                variant="outline-primary"
                type="reset"
                @click="drawerOpener = !drawerOpener"
                >Cancel</b-button
              >
              <b-button
                @click="addNewReq()"
                variant="outline-primary"
                class="float-end"
              >
                <i
                  v-if="isLoading"
                  class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                ></i
                >Save
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
    <!--Drawer For Open Booking Details  -->
    <!-- Method is use for open drawer -->
    <Drawer
      @close="
        () => {
          this.viewBookingDetails = false;
        }
      "
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1240"
      class="w-100"
    >
      <div v-if="viewBookingDetails">
        <BookingDetails :currentProps="bookingDetailsProps" />
      </div>
    </Drawer>
  </div>
</template>
